<template>
  <div class="body">
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit1']">
          <div class="visit-title">近12月诉讼统计</div>
          <div class="visit-chart2" ref="visit1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import ButlerHttp from "../../common/ButlerHttp";
export default {
  name: "LitigationStatisticsMonth",
  inject:['where','reginWhere'],
  data(){
    return{
      list:[],
      chart_list:{},
      chart_loading:{
        visit1:true,
        visit2:true,
        visit3:true,
        visit4:true,
        visit5:true,
        visit6:true,
        visit7:true
      },
    }
  },
  mounted() {
    const that=this;
    that.chart_list={}
    window.onresize=function () {
      let chart_list_ids=Object.keys(that.chart_list)
      chart_list_ids.map(ret=>{
        that.chart_list[ret].resize();
      });
    }
    this.reData()
  },
  methods:{
    reData(){
      const that = this;
      that.chart_loading.visit1=true;
      that.getData("5",list=>{
        that.getChart('visit1',visitOption1([
          {
            "type": 5,
            "type_ex": 1,
            "name": "提交"
          },
          {
            "type": 5,
            "type_ex": 2,
            "name": "诉调"
          },
          {
            "type": 5,
            "type_ex": 3,
            "name": "立案"
          },
        ],list))
        that.chart_loading.visit1=false;
      })
    },
    getData(select_type="1,2,3",callback){
      const that = this;
      let where = {}
      console.log(that.reginWhere)
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.area_id) where.area_id=that.reginWhere.area_id;
      where.select_type=select_type;
      ButlerHttp.post("Legal/statistics", where, res => {
        if (res.code) {
          if (that.list.length) {
            res.data.map((re, index) => {
              that.list[index] = {
                ...that.list[index],
                ...re
              };
            });
          } else {
            that.list = res.data;
          }
          typeof callback === "function" && callback(that.list);
          // that.initChartVisit()
        }
      });
    },
    getChart(id,option) {
      const that=this;
      let _chart={}
      if(that.chart_list[id]){
        _chart=that.chart_list[id];
        // _chart = echarts.getInstanceByDom(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }else {
        const _chart = echarts.init(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }
      return _chart;
    }
  },
  unmounted() {
    this.chart_list={}
  },
  watch:{
    "reginWhere.project_region":function (n) {
      this.reData()
    },
    "reginWhere.project_name":function (n) {
      this.reData()
    },
    "reginWhere.project_ids":function (n) {
      this.reData()
    },
    "reginWhere.area_id":function (n) {
      this.reData()
    },
  }
}

function rand(num=100) {
  return Math.floor(Math.random()*num)
}
function visitOption1(groupName=[],list) {
  let cateName=list.map(ret=>ret.ym);
  let cateData=[];
  let keys=[];
  if(groupName.length>1){
    groupName.push({
      "type": 100,
      "type_ex": 0,
      "name": "合计"
    })
    keys=groupName.map(ret=>{
      let k="count_"+ret.type;
      if(ret.type_ex){
        k=k+"_"+ret.type_ex
      }
      return k;
    })
    list=list.map(ret=>{
      ret.count_100=0;
      keys.forEach(val=>{
        if(val!=='count_100'){
          ret.count_100=ret.count_100+Number(ret[val]);
        }
      })
      return ret;
    })
  }

  groupName.forEach((ret,index)=>{
    let count_name='count_'+ret.type;
    if(ret.type_ex){
      count_name=count_name+'_'+ret.type_ex;
    }
    cateData[index]=list.map(ret=>ret[count_name]||0)
  })
  let d={
    "cateName":cateName,
    "cateData":cateData,
    "groupName":groupName.map(ret=>ret.name)
  }
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe'
  ];

  let series=[];
  groupName.forEach((ret,index)=>{
    if(ret.type===100){
      series[index]={
        name: ret.name,
        type: 'line',
        data: d.cateData[index],
        color:"#a964b4",
        label: {
          show: true,
          position: 'top'
        },
      }
    }else {
      series[index]={
        name: ret.name,
        type: 'bar',
        stack: "总数",
        data: d.cateData[index],
        color:colors[index],
        label: {
          show: true,
          position: 'top'
        },
      }
    }
  })


  return {
    grid: {
      x: '5%',
      width: '90%',
      // y: '12%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: d.groupName
    },
    xAxis: [
      {
        type: 'category',
        data: d.cateName,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '次',
      }
    ],
    series: series
  };
}
</script>

<style lang="scss" scoped>

.body{
  display: flex;
  flex-direction: column;
  background-color: aliceblue;
  .body-item{
    .body-item-header{
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }
    .body-item-main{
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1{
  width: calc( 50% - 30px );
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1{
    width: calc( 100% - 30px );
    height: calc(448px - 80px);
  }
  .visit-chart3{
    width: 400px;
    height: 400px;
  }
  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}


.visit2{
  width: calc( 100% - 10px );
  //height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-chart2{
    width: calc( 100% - 10px );
    height: calc(448px - 30px);
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/LitigationStatisticsMonth.vue